import { Lesson } from '@/models/Lesson'

class LessonOffer {
  constructor(
    id,
    lesson,
    senderId,
    receiverId,
    status,
    createdAt,
    updatedAt
  ) {
    if (!(typeof id === 'string')) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    if (!(lesson instanceof Lesson)) {
      throw new TypeError(`'lesson' must be an instance of [object Lesson]. Actual: ${typeof lesson}`)
    }
    if (!(typeof senderId === 'string')) {
      throw new TypeError(`The type of 'senderId' must be String. Actual: ${typeof senderId}`)
    }
    if (!(typeof receiverId === 'string')) {
      throw new TypeError(`The type of 'receiverId' must be String. Actual: ${typeof receiverId}`)
    }
    if (!(Object.values(OfferStatus).includes(status))) {
      throw new Error(`'status' must be an value of 'OfferStatus'. But ${status} is not.`)
    }
    this.id = id,
    this.lesson = lesson,
    this.senderId = senderId,
    this.receiverId = receiverId,
    this.status = status,
    this.createdAt = createdAt,
    this.updatedAt = updatedAt
  }

  hasId(id) {
    if (!(typeof id === "string")) {
      throw new TypeError(`The type of 'id' must be String. Actual: ${typeof id}`)
    }
    return (this.id === id)
  }

  hasStudentId(studentId) {
    if (!(typeof studentId === 'string')) {
      throw new TypeError(`The type of 'studentId' must be String. Actual: ${typeof studentId}`)
    }
    return this.lesson.hasStudentId(studentId)
  }

  isInOffer() {
    return (this.status === OfferStatus.inOffer)
  }

  isAgreed() {
    return (this.status === OfferStatus.agreed)
  }

  isDisagreed() {
    return (this.status === OfferStatus.disagreed)
  }

  toObject() {
    return {
      id: this.id,
      data: {
        lesson: this.lesson.toObject(),
        senderId: this.senderId,
        receiverId: this.receiverId,
        status: this.status,
        createdAt: this.createdAt,
        updatedAt: this.updatedAt
      }
    }
  }

  toAgreed() {
    this.status = OfferStatus.agreed
    return this
  }

  toDisagreed() {
    this.status = OfferStatus.disagreed
    return this
  }

}

class LessonOffers {
  constructor(offers) {
    if (!(offers instanceof Array)) {
      throw new TypeError(`'offers' must be an instance of [object Array]. Actual: ${typeof offers}`)
    }
    this.offers = offers
  }

  get() {
    return this.offers
  }

  length() {
    return this.offers.length
  }

  toObjects() {
    return this.offers.map(offer => {
      return offer.toObject()
    })
  }

  inOffers() {
    return new LessonOffers(this.offers.filter(offer => {
      return offer.isInOffer()
    }))
  }

  agreeds() {
    return new LessonOffers(this.offers.filter(offer => {
      return offer.isAgreed()
    }))
  }

  disagreeds() {
    return new LessonOffers(this.offers.filter(offer => {
      return offer.isDisagreed()
    }))
  }

  getStudentIds() {
    return this.offers.map(offer => offer.lesson.studentId)
  }

  filterByStudentId(studentId) {
    if (!(typeof studentId === 'string')) {
      throw new TypeError(`The type of 'studentId' must be String. Actual: ${typeof studentId}`)
    }
    return new LessonOffers(this.offers.filter(offer => offer.hasStudentId(studentId)))
  }

  remove(offerId) {
    if (!(typeof offerId === 'string')) {
      throw new TypeError(`The type of 'offerId' must be String. Actual: ${typeof offerId}`)
    }
    this.offers.splice(this.offers.findIndex(one => one.hasId(offerId)), 1)
    return this
  }

  filterSenderId() {
    const senderIds = this.offers.map(offer => offer.senderId)
    return senderIds.filter((senderId, i, self) => self.indexOf(senderId) === i)
  }
}

const OfferStatus = {
  inOffer: "IN_OFFER",
  agreed: "AGREED",
  disagreed: "DISAGREED"
}

Object.freeze(OfferStatus)

export { LessonOffer, LessonOffers, OfferStatus }